(function () {
  const STORAGE_KEY = 'jintashop_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function isSaved(productId) {
    return getWishlist().some(item => String(item.id) === String(productId));
  }

  function addProduct(product) {
    const items = getWishlist();
    if (!items.some(item => String(item.id) === String(product.id))) {
      items.push(product);
      saveWishlist(items);
    }
  }

  function removeProduct(productId) {
    const items = getWishlist().filter(item => String(item.id) !== String(productId));
    saveWishlist(items);
  }

  function updateButtonState(btn) {
    if (!btn) return;
    const saved = isSaved(btn.dataset.productId);
    btn.classList.toggle('is-active', saved);
    btn.setAttribute('aria-label', saved ? 'Retirer des favoris' : 'Ajouter aux favoris');
  }

  function updateAllButtons() {
    document.querySelectorAll('.js-wishlist-btn').forEach(updateButtonState);
  }

  function updateHeaderCount() {
    const count = getWishlist().length;
    document.querySelectorAll('.header-favorites-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-block' : 'none';
    });
  }

  function renderDrawer() {
    const container = document.getElementById('favorites-drawer-content');
    if (!container) return;

    const items = getWishlist();

    if (!items.length) {
      container.innerHTML = '<p class="favorites-drawer__empty">Vous n’avez pas encore ajouté de favoris.</p>';
      return;
    }

    container.innerHTML = items.map(function (item) {
      return `
        <div class="favorite-item" data-product-id="${item.id}">
          <a class="favorite-item__image" href="${item.url}">
            <img src="${item.image || ''}" alt="${item.title || ''}">
          </a>
          <div class="favorite-item__info">
            <a class="favorite-item__title" href="${item.url}">${item.title || ''}</a>
            <div class="favorite-item__price">${item.price || ''}</div>
          </div>
          <button class="favorite-item__remove" type="button" data-remove-id="${item.id}">
            Retirer
          </button>
        </div>
      `;
    }).join('');
  }

  function refreshWishlistUI() {
    updateAllButtons();
    updateHeaderCount();
    renderDrawer();
  }

  function showToast(message) {
    const toast = document.getElementById('favorites-toast');
    if (!toast) return;

    toast.textContent = message;
    toast.classList.add('is-visible');

    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 1500);
  }

  function openDrawer() {
    const drawer = document.getElementById('favorites-drawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
  }

  function closeDrawer() {
    const drawer = document.getElementById('favorites-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
  }

function moveDrawerToBody() {
  const drawer = document.getElementById('favorites-drawer');
  if (!drawer) return;

  if (drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }
}

function init() {
  moveDrawerToBody();
  refreshWishlistUI();
}

  document.addEventListener('click', function (e) {
    const wishlistBtn = e.target.closest('.js-wishlist-btn');
    if (wishlistBtn) {
      e.preventDefault();
      e.stopPropagation();

      const product = {
        id: wishlistBtn.dataset.productId,
        handle: wishlistBtn.dataset.productHandle,
        title: wishlistBtn.dataset.productTitle,
        url: wishlistBtn.dataset.productUrl,
        image: wishlistBtn.dataset.productImage,
        price: wishlistBtn.dataset.productPrice
      };

      if (!product.id) {
        console.warn('Wishlist: data-product-id manquant');
        return;
      }

      if (isSaved(product.id)) {
        removeProduct(product.id);
        showToast('Produit retiré des favoris');
      } else {
        addProduct(product);
        showToast('Produit ajouté aux favoris');
      }

      refreshWishlistUI();
      return;
    }

    const headerBtn = e.target.closest('.header-favorites-button');
    if (headerBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }

    const closeBtn = e.target.closest('.favorites-drawer__close');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    const overlay = e.target.closest('.favorites-drawer__overlay');
    if (overlay) {
      closeDrawer();
      return;
    }

    const removeBtn = e.target.closest('[data-remove-id]');
    if (removeBtn) {
      e.preventDefault();
      removeProduct(removeBtn.dataset.removeId);
      refreshWishlistUI();
      return;
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    moveDrawerToBody();
    refreshWishlistUI();
  });
})();